export const setNocState = (payload) => {
  return {
    type: "SET_NOC_STATE",
    payload,
  };
};

export const updateDotState = (item) => {
  return (dispatch, getState) => {
    const { dotStates } = getState().nocState;

    const newDot = ((dotStates?.[item] || 0) + 1) % 4;

    dispatch({
      type: "UPDATE_DOT_STATE",
      payload: {
        item,
        value: newDot,
      },
    });
  };
};

export const setNocIntervalId = (item, intervalId) => ({
  type: "SET_NOC_INTERVAL_ID",
  payload: { item, intervalId },
});

export const clearNocIntervalId = (item) => ({
  type: "CLEAR_NOC_INTERVAL_ID",
  payload: item,
});

export const setNocProgressCompleted = (item) => ({
  type: "SET_NOC_PROGRESS_COMPLETED",
  payload: item,
});

export const addNocStateItems = (value) => ({
  type: "ADD_NOC_STATE_ITEMS",
  payload: value,
});

export const updateNocProgress = (payload) => ({
  type: "UPDATE_NOC_PROGRESS",
  payload,
});
